import React from "react";
import classes from "../../../InviteCode.module.scss";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

import InviteContainer from "../InviteContainer";

//Componente link de convite
const LinkInviteCode = ({
  inviteCodeLink, // Código do link gerado
  isLinkCodeCopied, // Estado se o link já foi copiado
  isFetching, // Estado de carregamento para mostrar spinner
  fetchCodeHandler, // Função para gerar/gerar novo link
  copyLinkToClipboardHandler, // Função para copiar link
  upgradeAlert, // Componente ou mensagem para alerta de upgrade
  hasError, // Indica se houve erro
}) => {
  const { t } = useTranslation();

  return (
    <InviteContainer
      title={t("inviteUsers.invite_link")} // Título do card
      description={t("inviteUsers.create_a_deep_link")} // Descrição abaixo do título
      value={inviteCodeLink} // Valor do link gerado
      isCopied={isLinkCodeCopied} // Mostra se o link foi copiado
      isFetching={isFetching} // Mostra spinner se carregando
      onCopy={copyLinkToClipboardHandler} // Função ao clicar em copiar
      onGenerate={fetchCodeHandler} // Função ao clicar em gerar link
      generateButtonText={t("inviteUsers.generate_link")}
      icon={faLink}
      classes={classes} 
      upgradeAlert={upgradeAlert} // Exibe alerta para upgrade, se houver
      hasError={hasError} // Indica se existe erro para mostrar alerta
      type="link"
    />
  );
};

export default LinkInviteCode;
